<template>
  <el-color-picker ref="rcColorPicker" :value="value" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
export default {
  name: "RcColorPicker",
  props: {
    value: String
  }
};
</script>
